'use client';

import { createContext, SetStateAction, useState, Dispatch, useContext } from 'react';

type ModalContextType = {
  modal: boolean;
  setModal: Dispatch<SetStateAction<boolean>>;
};

export const ModalContext = createContext({} as ModalContextType);

export function ModalProvider({ children }) {
  const [modal, setModal] = useState(false);

  return (
    <ModalContext.Provider
      value={{
        modal,
        setModal
      }}
    >
      {children}
    </ModalContext.Provider>
  );
}

export const useModalContext = () => {
  const context = useContext(ModalContext);

  if (!context) {
    throw new Error('useLocationContext must be used within an LocalizationProvider');
  }

  return context;
};
